

import { Component, Vue, VModel, Emit, Prop } from 'vue-property-decorator';
import IBDialog from '@/components/Dialog/IBDialog.vue';

@Component({
	components: {
		IBDialog
	}
})
export default class PaymentRequirementsSuccessDialog extends Vue {

	@VModel({ type: Boolean })
	model!: boolean

	@Prop(Number)
	readonly totalCount?: number

	@Prop(Number)
	readonly processedCount?: number

	@Prop(Boolean)
	readonly hint?: boolean

	@Emit("confirmed")
	emitConfirmed() {}

	@Emit("close")
	emitClose() {}

}

